module.exports = __webpack_public_path__ + "static/segmentedtimeline-40d966b8e381b510b4c2a2af0cd38f3d.jpg";